import type { VehicleInsurance } from '@makemydeal/dr-platform-types';

export type SyncVehicleInsurance = {
    companyName?: string;
    agentName?: string;
    phoneNumber?: string;
    policyNumber?: string;
    policyExpirationDate?: string;
    collisionDeductible?: number;
    comprehensiveDeductible?: number;
    companyAddress?: {
        street1?: string;
        city?: string;
        state?: string;
        zip?: string;
    };
};

/** Maps the subset of VehicleInsurance fields mapped to Common Consumer's individual.insurance.primary shape. */
export const mapVehicleInsuranceForSync = (insurance: VehicleInsurance): SyncVehicleInsurance => ({
    companyName: insurance.insuranceCompany,
    agentName: insurance.agentName,
    phoneNumber: insurance.agentPhoneNumber,
    policyNumber: insurance.policyNumber,
    policyExpirationDate: insurance.policyExpirationDate as unknown as string,
    collisionDeductible: insurance.deductibles?.collisionDeductible,
    comprehensiveDeductible: insurance.deductibles?.comprehensiveDeductible,
    companyAddress: {
        street1: insurance.agentAddress?.addressLine1,
        city: insurance.agentAddress?.city,
        state: insurance.agentAddress?.stateProvince,
        zip: insurance.agentAddress?.postalCode
    }
});
